import { QueryFactory } from "../../../../Common";
import { Casino } from "../../../../Contracts";
export const QGetGames = QueryFactory(Casino.QueryTypes.GetGames);
//# sourceMappingURL=QGetGames.js.map